import {
  EvaluationResultSpecific,
  Metric,
} from '@agilelab/plugin-wb-governance-common';
import {
  WbCard,
  WbCardContent,
  WbTabs,
  WbWidget,
} from '@agilelab/plugin-wb-platform';
import { Box } from '@material-ui/core';
import { FC, useMemo, useState } from 'react';
import { GovernanceTestOverviewInfo } from '../GovernanceTestOverviewInfo';
import { GovernanceTestOverviewMetricDetails } from './MetricErrorsDetails';
import { GovernanceTestOverviewMetricInfo } from './OverviewMetricInfoBox';

interface Props {
  result?: EvaluationResultSpecific;
  metric: Metric;
  infoContent?: JSX.Element;
  test?: {
    errors?: string[];
    content: string;
    name: string;
  };
}

enum Tab {
  Result,
  Entity,
}

export const GovernanceTestOverviewMetricTabs: FC<Props> = props => {
  const [selectedTab, setSelectedTab] = useState<Tab>(Tab.Result);

  const test = useMemo(() => {
    if (props.test) return props.test;

    if (props.result)
      return {
        errors: props.result.result?.errors || [],
        content: props.result.resource_content,
        name:
          props.result.resource_display_name ||
          props.result.resource.external_id,
      };

    return undefined;
  }, [props.result, props.test]);
  return (
    <WbCard
      cardStyle={{ height: '100%' }}
      title="Overview"
      toolsComponents={
        <WbTabs
          tabs={[
            {
              name: 'Result',
              action: () => {
                setSelectedTab(Tab.Result);
              },
              selected: selectedTab === Tab.Result,
            },
            {
              name: 'Metric',
              action: () => {
                setSelectedTab(Tab.Entity);
              },
              selected: selectedTab === Tab.Entity,
            },
          ]}
        />
      }
    >
      <WbCardContent>
        {selectedTab === Tab.Result ? (
          <Box
            style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
          >
            {props.infoContent ? (
              <WbWidget title="Info">
                <WbCardContent>{props.infoContent}</WbCardContent>
              </WbWidget>
            ) : (
              props.result && (
                <GovernanceTestOverviewInfo result={props.result} />
              )
            )}
            {test && (
              <GovernanceTestOverviewMetricDetails {...props} test={test} />
            )}
          </Box>
        ) : (
          <GovernanceTestOverviewMetricInfo {...props} />
        )}
      </WbCardContent>
    </WbCard>
  );
};
